// extracted by mini-css-extract-plugin
export var center = "_d-2";
export var clickableRow = "_d-5";
export var expandedRow = "_d-7";
export var hoverable = "_d-4";
export var left = "_d-1";
export var right = "_d-3";
export var row = "_d-0";
export var selectedRow = "_d-6";
export var summaryRow = "_d-8";